import { useCookies } from 'react-cookie'
import { useQuery } from 'react-query'

import { SITE_COOKIE } from '@hapana/shared/constants/cookies.constant'
import { GENERIC_ERROR_KEY } from '@hapana/shared/constants/errors.constants'
import { TIME_FORMAT_KEY, TIME_ZONE_KEY } from '@hapana/shared/constants/local-storage.constants'
import { getConfiguration, getTimeFormat } from '../services/configuration.service'

import { useErrorHandler } from './errors.hooks'
import { useSiteId } from './site.hooks'

export const useSiteConfiguration = () => {
  const { data: siteId, isSuccess } = useSiteId()
  const [cookies] = useCookies([SITE_COOKIE])
  const cookieData = cookies?.[SITE_COOKIE]

  if (!cookieData?.tenant || !cookieData?.v1SiteId) {
    return {
      data: { timezone: 'UTC' },
      isSuccess: true,
    }
  }

  const { tenant, v1SiteId } = cookieData
  const { onError } = useErrorHandler(GENERIC_ERROR_KEY)

  const timezone = localStorage.getItem(`${tenant}_site_${v1SiteId}_${TIME_ZONE_KEY}`)

  const onSuccess = ({ timezone }) => {
    if (timezone) {
      localStorage.setItem(`${tenant}_site_${v1SiteId}_${TIME_ZONE_KEY}`, timezone)
    }
  }

  const query = useQuery(getConfiguration.key, getConfiguration.query, {
    select: (data) => data?.site?.configurations,
    enabled: isSuccess,
    meta: {
      siteId,
    },
    onSuccess,
    onError,
  })

  return !query.data && timezone
    ? {
        data: { timezone },
        isSuccess: true,
      }
    : query
}

export const useTimeFormat = () => {
  const { data: siteId, isSuccess } = useSiteId()
  const [cookies] = useCookies([SITE_COOKIE])
  const cookieData = cookies?.[SITE_COOKIE]

  if (!cookieData?.tenant || !cookieData?.v1SiteId) {
    return {
      data: { timeFormat: 'HH:mm' },
      isSuccess: true,
    }
  }

  const { tenant, v1SiteId } = cookieData
  const { onError } = useErrorHandler(GENERIC_ERROR_KEY)

  const timeFormat = localStorage.getItem(`${tenant}_site_${v1SiteId}_${TIME_FORMAT_KEY}`)

  const onSuccess = ({ timeFormat }) => {
    if (timeFormat) {
      localStorage.setItem(`${tenant}_site_${v1SiteId}_${TIME_FORMAT_KEY}`, timeFormat)
    }
  }

  const query = useQuery(getTimeFormat.key, getTimeFormat.query, {
    select: (data) => data?.site?.configurations,
    enabled: isSuccess && !timeFormat,
    meta: {
      siteId,
    },
    onSuccess,
    onError,
  })

  return timeFormat
    ? {
        data: { timeFormat },
        isSuccess: true,
      }
    : query
}
